import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { PrivateRoute } from '../helpers/PrivateRoute'

import { 
  LandingPage, 
  NotFound, 
  Components, 
  SignUp, 
  Login, 
  ForgotPassword, 
  CheckMail, 
  NewPassword, 
  PasswordReset, 
  NewsFeed, 
  AdvancedSearch,
  Faqs,
  Operations,
  ExternalResources,
  SingleCategory,
  NigerianaCategories,
  NigerianNewspapers
} from '../pages'
import { ArticlePage } from '../pages/article'
import { Dashboard } from '../pages/dashboard'
import { 
  DashHome,
  Collections,
  Resources,
  FaqDash,
  NewsPaper,
  Users,
  Settings,
  DashCategory,
  DashTags,
  AddFaqs
 } from '../pages/dashboard/screens'

import {TestPage}  from '../pages/textpage'


import NigerianaPublications from '../pages/nigerianapub'

const AppRouter = () => {

  useEffect(() => {
    window.history.scrollRestoration = 'manual'
  }, []);
  return (
    <Router>
        <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path='/nigeriana' element={ <NigerianaPublications/> } />
            <Route path='/newspaper-feed' element={ <NewsFeed /> } />
            <Route path='/advanced-search' element={ < AdvancedSearch /> } />
            <Route path='/faqs' element={ < Faqs /> } />
            <Route path='/operations' element={ <Operations /> } />
            <Route path='/nigerian-newspapers' element={ <NigerianNewspapers /> }  />
            <Route path='/open-access-resources' element={ <ExternalResources/> }  />
            <Route path='/nigeriana-categories' element={ <NigerianaCategories /> } />
            <Route path='/nigeriana/category/:resourceCategoryId' element={ <SingleCategory /> } />
            <Route path='/nigeriana/category/' element={ <SingleCategory /> } />
            <Route path='/resource/:resourceNlnCode' element={ <ArticlePage /> } />
            <Route path='/nigeriana/resource/:resourceNlnCode' element={ <ArticlePage /> } />
            <Route path='/open-access/resource/:resourceNlnCode' element={ <ArticlePage /> } />
            <Route path='/sign-up' element={<SignUp/>} />
            <Route path='/login' element={ <Login /> } />
            <Route path='/forgot-password' element={ <ForgotPassword /> } />
            <Route path='/checkmail' element={ <CheckMail /> } />
            <Route path='/new-password' element={<NewPassword />} />
            <Route path='/password-reset' element={ <PasswordReset /> } />
            <Route path='/components' element={<Components />} />
            <Route path='/test-page' element={ <TestPage /> } />

          
            <Route path='/' element={ 
            
            // <PrivateRoute>
                <Dashboard />
            // </PrivateRoute>  *
            
            } >
                <Route path='/dashboard/home' element={<DashHome/>} />
                {/* <Route path='/dashboard/my-collections' element={ <Collections /> } /> */}
                <Route path='/dashboard/resources' element={<Resources />} />
                <Route path='/dashboard/resources/category' element={ <DashCategory /> } />
                <Route path='/dashboard/resources/tags' element={ <DashTags /> } />
                <Route path='/dashboard/faqs' element={<FaqDash />} />
                <Route path='dashboard/faqs/add-category' element={ <AddFaqs /> } />
                <Route path='/dashboard/newspapers' element={<NewsPaper />} />
                <Route path='/dashboard/users' element={<Users />} />
                <Route path='/dashboard/roles' element={ <Settings/> } />
                
            </Route>

            <Route path="*" element={<NotFound />} />
            
        </Routes>
    </Router>
  )
}

export {AppRouter}